module.exports = __webpack_public_path__ + "img/logo-m2n.42db35a4.svg";